module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/mainBg_0633388cc08fc5f390cc1f5dece89171.jpg";